import { Box } from '@chakra-ui/react';
import moment from 'moment';

import { TextRegular } from 'UiKit/typography';
import { getMenuPermissions } from 'Helper/getMenuPermissions';

import ActionButton from 'View/brief-live/component/action-button';
import StatusBadge from 'View/brief-live/component/status-badge';
import AllocatedStockColumn from 'View/brief-live/component/giveaway-columns/allocated-stock-column';
import PrizesColumn from 'View/brief-live/component/giveaway-columns/prizes-column';
import UsedStockColumn from 'View/brief-live/component/giveaway-columns/used-stock-column';

import { getGiveawayStatutes } from './statusConfig';

import styles from './styles.module.css';

const tableListGiveaway = ({ t }) => {
  const accessPermission = getMenuPermissions('others', 'briefs');

  const tableList = [
    {
      name: t('tableGiveaway.timeCreated'),
      width: 120,
      key: 'createdAt',
      sortKey: 'createdAt',
      component: ({ value }) => (
        <TextRegular className={styles['column__text']}>
          {moment(value).format('DD MMM YY')}
          <br />
          {moment(value).format('HH:mm')}
        </TextRegular>
      ),
    },
    {
      name: t('tableGiveaway.giveaway'),
      width: 242,
      key: 'title',
      component: ({ value }) => <TextRegular className={styles['column__text']}>{value}</TextRegular>,
    },
    {
      name: t('tableGiveaway.prize'),
      width: 350,
      key: 'giveaways',
      component: ({ value, values }) => <PrizesColumn value={value} values={values} />,
    },
    {
      name: t('tableGiveaway.stock'),
      width: 79,
      key: 'giveaways',
      component: ({ value }) => <AllocatedStockColumn value={value} />,
    },
    {
      name: t('tableGiveaway.usedStock'),
      width: 130,
      key: 'giveaways',
      component: ({ value, values }) => (
        <Box className={styles['column__used-stock']}>
          <UsedStockColumn value={value} values={values} />
        </Box>
      ),
    },
    {
      name: t('tableGiveaway.status'),
      width: 100,
      key: 'status',
      component: ({ value }) => (
        <Box className={styles['column__text']}>
          <StatusBadge {...(getGiveawayStatutes({ t, status: value }) || {})} />
        </Box>
      ),
    },
  ];

  if (accessPermission?.isCanEdit || accessPermission?.isCanDelete) {
    tableList.push({
      name: t('tableGiveaway.action'),
      key: 'action',
      width: 120,
      position: 'center',
      component: ({ values }) => (
        <Box className={styles['column__text']}>
          <ActionButton values={values} accessPermission={accessPermission} />
        </Box>
      ),
    });
  }

  return tableList;
};

export default tableListGiveaway;
